import React, {useState, useEffect, useRef, Ref} from 'react';

// the useSelector is kind of mapstatetoprops
import {useDispatch} from 'react-redux';

import {useTypedSelector} from '../../../hooks/useTypeSelector';

import ButtonLoader, {IButtonLoaderRef} from '../../../com/buttonLoader/ButtonLoader';

import {actionCreators} from '../../../store';

import PasswordInput from '../../../com/passwordInput/PasswordInput';
import TextInput from '../../../com/textInput/TextInput';

import {IAuthParamsDto, RegisterDto} from '../../../dtos';

import './RegisterForm.scss';

import {
    validEmailRegex,
    getVariableName,
    isUsableInsideUrl,
    getUnusableCharacterInsideUrl
} from '../../../helpers/utils';
import {ActionType} from '../../../store/actionTypes';
import {useParams} from "react-router-dom";
import {EmailSent, IEmailSentRef} from "../emailSent/EmailSent";
import {makeStyles} from "@mui/styles";
import {Box, Typography} from "@mui/material";
import 'react-phone-number-input/style.css'

const useStyles = makeStyles(() => ({
    formWrapper: {
        width: "100%"
    },
    textEventsWrapper: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px"
    },
    textEventBox: {
        display: "flex",
        flexFlow: "column",
        rowGap: "4px",
        "& > .MuiTypography-root": {
            fontSize: "14px"
        }
    },
}))

interface IRegisterForm {
    onSigninClick: () => void;
    onRegisterSucceeded: () => void;
    refEmail: Ref<IEmailSentRef>;
}

const RegisterForm: React.FC<IRegisterForm> = (props) => {

    const classes = useStyles();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [fullName, setFullName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [company, setCompany] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    // const [userName, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const {projectName} = useParams<IAuthParamsDto>();
    const [sentEmail, setSentEmail] = useState<boolean>(false);
    // for testing 
    // const [firstName, setFirstName] = useState('John');
    // const [lastName, setLastName] = useState('Doe');
    // const [company, setCompany] = useState('johndoecompany');
    // const [emailAddress, setEmailAddress] = useState('johndoe@gmail.com');
    // const [userName, setUsername] = useState('johny');
    // const [password, setPassword] = useState('123456');

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        fullName: '',
        company: '',
        emailAddress: '',
        phoneNumber: '',
        // userName: '',
        password: '',
    });

    const hooksNames: string[] = [
        getVariableName({fullName}),
        getVariableName({firstName}),
        getVariableName({lastName}),
        getVariableName({company}),
        getVariableName({phoneNumber}),
        getVariableName({emailAddress}),
        // getVariableName({userName}),
        getVariableName({password}),
    ];


    const {data, error, loading, type} = useTypedSelector((state) => state.auth);

    const dispatch = useDispatch();

    let buttonLoaderRef = useRef<IButtonLoaderRef>(null);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();


        if (!isFormdValid()) {
            return;
        }

        let registerDto: RegisterDto = {
            firstName,
            lastName,
            // fullName,
            company,
            emailAddress,
            // userName,
            password,
            // phoneNumber,
            accountTier: 1
            // accountTier: projectName === 'flyersCatalog' ? 10 : 1
        }

        buttonLoaderRef.current?.showLoader(true);

        dispatch(actionCreators.register(registerDto));
    }

    const isFormdValid = () => {

        let allErrors = validate();

        // if length === 0 => true
        // else false
        return Object.values(allErrors).join('').length === 0;
    }

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>, hookName: string, hookFunction: React.Dispatch<React.SetStateAction<any>>) => {
        var value = event.target.value;
        hookFunction(value);

        validate(hookName, value);
    }

    const onChangePhoneNumber = (phoneNumberString: string = "") => {
        setPhoneNumber(phoneNumberString);

        validate(getVariableName({phoneNumber}), phoneNumberString);
    };


    const validate = (hookName?: string, enforceValue?: any) => {

        let allErrors: any = {...errors}

        hooksNames.forEach(name => {
            let currentError = validateInput(name, enforceValue);

            if (hookName) {
                // validate only 1 input
                if (name === hookName) {
                    allErrors[name] = currentError;
                }
            } else {
                // validate all inputs
                allErrors[name] = currentError;
            }
        });

        setErrors(allErrors);

        return allErrors;
    }

    const validateInput = (name: string, enforceValue?: any) => {

        let value = null;
        let err = '';

        if (enforceValue === undefined) {
            switch (name) {

                case getVariableName({firstName}):
                    value = enforceValue ? enforceValue : firstName
                    err = value.length < 2
                        ? 'First Name must be at least 2 characters'
                        : ''
                    break;

                case getVariableName({lastName}):
                    value = enforceValue ? enforceValue : lastName
                    err = value.length < 3
                        ? 'Last Name must be at least 3 characters'
                        : ''
                    break;
                /*
                            case getVariableName({fullName}):
                                value = enforceValue ? enforceValue : fullName
                                err = value.length < 3
                                    ? 'Full Name must include 2 or more letters'
                                    : ''
                                break;

                            case getVariableName({phoneNumber}):
                                value = enforceValue !== undefined ? enforceValue : phoneNumber;
                                const isMobilePhoneEmail = validator.isMobilePhone(value);
                                if (value !== "" && !isMobilePhoneEmail) {
                                    err = value.length < 3
                                        ? 'Incorrect Phone Number'
                                        : ''
                                }
                                break;
                */
                case getVariableName({company}):
                    value = enforceValue ? enforceValue : company
                    err = value.length < 3
                        ? 'Company must be at least 3 characters'
                        : ''

                    if (err.length === 0) {
                        if (!isUsableInsideUrl(value)) {
                            let invalidCharacterInsideUrl = getUnusableCharacterInsideUrl()
                            err = `Company contain invalid character (${invalidCharacterInsideUrl})`
                        }
                    }

                    break;

                case getVariableName({emailAddress}):
                    value = enforceValue ? enforceValue : emailAddress
                    err = !validEmailRegex.test(value)
                        ? 'Email address is wrong'
                        : ''
                    break;

                // case getVariableName({userName}):
                //     value = enforceValue ? enforceValue : userName
                //     err = value.length < 3
                //         ? 'User Name must be at least 3 characters long'
                //         : ''
                // break;

                case getVariableName({password}):
                    value = enforceValue ? enforceValue : password
                    err = value.length < 6
                        ? 'Password must be at least 6 characters'
                        : ''
                    break;
            }
        }

        return err;
    }

    const delay = 500;

    useEffect(() => {
        if (type === ActionType.REGISTER_SUCCESS) {
            setTimeout(() => {
                //history.push('/flyersCatalog')
                props.onRegisterSucceeded();
                setSentEmail(true);
            }, delay);
        }
    })

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                buttonLoaderRef.current?.showLoader(false);
            }, delay);
        }
    }, [loading])

    if (sentEmail) {
        return <EmailSent
            ref={props.refEmail}
            onResendAnotherEmailClick={() => {
            }}
        />
    }

    return (
        <Box className={classes.formWrapper}>
            <Typography textAlign={"center"}
                        sx={{
                            fontSize: "28px",
                            textAlign: "center",
                            marginBottom: "32px",
                            fontWeight: 500
                        }}

            >
                Register
            </Typography>

            <form className="auth_item_container_form" noValidate onSubmit={onSubmit}>
                <div>
                    <TextInput
                        placeHolder="Company"
                        type="text"
                        value={company}
                        onChange={e => onInputChange(e, getVariableName({company}), setCompany)}
                        errorMessage={errors.company}
                        isRequired={true}
                    />
                </div>
                <div>
                    <TextInput
                        placeHolder="First Name"
                        type="text"
                        value={firstName}
                        onChange={e => onInputChange(e, getVariableName({firstName}), setFirstName)}
                        errorMessage={errors.firstName}
                        isRequired={true}
                    />
                </div>
                <div>
                    <TextInput
                        placeHolder="Last Name"
                        type="text"
                        value={lastName}
                        onChange={e => onInputChange(e, getVariableName({lastName}), setLastName)}
                        errorMessage={errors.lastName}
                        isRequired={true}
                    />
                </div>
                {/*
                <div>
                    <TextInput
                        placeHolder="Full Name"
                        type="text"
                        value={fullName}
                        onChange={e => onInputChange(e, getVariableName({fullName}), setFullName)}
                        errorMessage={errors.fullName}
                        isRequired={true}
                    />
                </div>
*/}
                {/*
                <Box>
                    <PhoneInput
                        style={{
                            width: `100%`,
                        }}
                        className={`
                                        ${styles.phoneInput} 
                                        phoneInputRegister
                                        ${Boolean(errors.phoneNumber) ? styles.error_signal : ''}
                                    `}
                        placeholder="Phone Number"
                        value={phoneNumber}
                        onChange={onChangePhoneNumber}
                        disabled={false}
                        smartCaret={false}
                    />
                    <Typography height={"24px"} m={"4px 12px"} fontSize={"14px"}
                                color={"#FF0404"}>{Boolean(errors.phoneNumber) ? errors.phoneNumber : ''}</Typography>

                </Box>
*/}
                <div>
                    <TextInput
                        placeHolder="Work Email Address"
                        type="email"
                        value={emailAddress}
                        onChange={e => onInputChange(e, getVariableName({emailAddress}), setEmailAddress)}
                        errorMessage={errors.emailAddress}
                        isRequired={true}
                    />
                </div>
                <div>
                    <PasswordInput
                        value={password}
                        onChange={e => onInputChange(e, getVariableName({password}), setPassword)}
                        errorMessage={errors.password}
                    />
                </div>

                <ButtonLoader ref={buttonLoaderRef}>
                    REGISTER
                </ButtonLoader>
                <Box className={classes.textEventsWrapper}>
                    <Box className={classes.textEventBox}>
                        <Typography color={"#828282"}>
                            Already Have any account?
                        </Typography>
                        <Typography onClick={props.onSigninClick} fontWeight={500}
                                    sx={{
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                        >
                            Sign In
                        </Typography>
                    </Box>
                </Box>
            </form>
        </Box>
    )
}

export default RegisterForm;
